export const spacing = (factor: number) => `${0.5 * factor}rem`;
export const remToPx = (value: string) => parseFloat(value) * 16;
export const pxToRem = (px: number) => `${px / 16}rem`;